import { defineComponent as l, openBlock as i, createBlock as u, unref as r, mergeProps as s, withCtx as n, renderSlot as f } from "vue";
import o from "./ghl-ui.es319.js";
const b = l({
  name: "UIDatepicker"
}), m = l({
  ...b,
  props: {
    type: {
      type: String,
      default: "date"
    },
    clearable: {
      type: Boolean,
      default: !1
    },
    panel: {
      type: Boolean,
      default: !1
    },
    isDateDisabled: {
      type: Function
    },
    isTimeDisabled: {
      type: Function
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      required: !0
    },
    shortcuts: {
      type: Object,
      default: void 0
    },
    value: {
      type: [Number, Array]
    },
    defaultValue: {
      type: [Number, Array]
    },
    format: {
      type: String
    }
  },
  setup(e) {
    return (t, a) => (i(), u(r(o), s({ id: e.id }, t.$attrs, {
      disabled: e.disabled,
      "is-date-disabled": e.isDateDisabled,
      "is-time-disabled": e.isTimeDisabled,
      panel: e.panel,
      value: e.value,
      "default-value": e.defaultValue,
      "onUpdate:value": a[0] || (a[0] = (d) => t.$emit("update:value", d)),
      clearable: e.clearable,
      type: e.type,
      size: "large",
      shortcuts: e.shortcuts,
      format: e.format
    }), {
      default: n(() => [
        f(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "disabled", "is-date-disabled", "is-time-disabled", "panel", "value", "default-value", "clearable", "type", "shortcuts", "format"]));
  }
}), p = m;
export {
  p as default
};
